import moment from "moment";
import React, { useEffect, useState } from "react";
import { fileRestoreAPI, viewHistoryRecordsAPI } from "src/api/DataCenterApi";
import { toast } from 'react-toastify';

const styles = {
    offcanvas: {
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        maxHeight: "90vh",
        background: "#fff",
        zIndex: 1055,
        transition: "transform 0.3s ease-in-out",
        transform: "translateY(100%)", // hidden by default
    },
    show: {
        transform: "translateY(0%)", // slide up when visible
    },
    backdrop: {
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0,0,0,0.5)",
        zIndex: 1050,
    },
};

const ViewVersionModal = ({ isOpen, onClose, version }) => {
    const [headers, setHeaders] = useState([]);
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filteredRows, setFilteredRows] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');


    const fetchVersionData = async () => {
        setLoading(true);
        try {
            const response = await viewHistoryRecordsAPI({ fileHistoryId: version?._id })
            setHeaders(response?.data?.data?.headers || []);
            setRows(response?.data?.data?.rows || []);
            setFilteredRows(response?.data?.data?.rows || []);
        } catch (error) {
            console.error('Failed to fetch version data:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        // if (!isOpen || !version?.fileHistoryId) return;
        fetchVersionData();
    }, [isOpen, version]);

    const handleExport = async () => {
        try {
            const link = document.createElement('a');
            link.href = version?.fileUrl;
            link.download = version?.fileName;
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error("Export failed:", error);
        }
    };

    const handleRestore = async () => {
        try {
            setLoading(true)
            const res = await fileRestoreAPI({ fileHistoryId: version?._id });
            setLoading(false)
            toast.success('File restore successfully')
        } catch (error) {
            console.error('Error restoring version:', error);
        }
    };

    const handleSearchChange = (e) => {
        console.log('e', e)
        const query = e.target.value.toLowerCase();
        setSearchQuery(query);

        if (query === '') {
            setFilteredRows(rows);
        } else {
            const filtered = rows.filter((row) => {
                return headers.some((header) => {
                    const cellValue = row[header]?.toString().toLowerCase();
                    return cellValue?.includes(query);
                });
            });
            setFilteredRows(filtered);
        }
    };

    if (!isOpen || !version) return null;

    return (
        <div
            style={{
                ...styles.offcanvas,
                ...(isOpen ? styles.show : {}),
            }}
            className="custom-offcanvas-bottom versHistoryPopup show"
        >
            <div className="offcanvas-header">
                <div className="d-flex align-items-center gap-24">
                    <button className="iconClose" onClick={onClose} aria-label="Close">
                        <img src="./assets/images/data-center/down-arrow.svg" alt="Close" />
                    </button>
                    <h5 className="offcanvas-title">
                        Version History{" "}
                        <span>{moment(version?.updatedTs).format('MMM D, YYYY, h:mm a') || "Date not available"}</span>
                    </h5>
                </div>
                <div className="versCancelData">
                    <div className="d-flex gap-12 align-items-center">
                        <h6>Modified by</h6>
                        <div className="d-flex align-items-center gap-2">
                            <span className="userimg" style={{ backgroundColor: "rgb(110, 60, 18)", color: "white" }}>
                                {version?.userInfo[0]?.firstName?.charAt(0)}{version?.userInfo[0]?.lastName?.charAt(0)}
                            </span>
                            <div>
                                <h6 className="text-md mb-0 fw-medium text-primary-600">
                                    {version?.userInfo[0]?.firstName} {version?.userInfo[0]?.lastName}

                                </h6>
                            </div>
                        </div>
                    </div>
                    <button className="iconClose" onClick={onClose} aria-label="Close">
                        ✕
                    </button>
                </div>
            </div>

            <div className="offcanvas-body small">
                <div className="d-flex align-items-center pb-24 justify-content-between flex-wrap">
                    <div className="d-flex gap-2 align-items-center">
                        <div className="search w-100">
                            <input
                                type="text"
                                className="form-control radius-8"
                                placeholder="Search"
                                value={searchQuery}
                                onChange={handleSearchChange}
                            />
                        </div>
                    </div>
                    <div className="d-flex align-items-center gap-16">
                        <div className="exportBtn">
                            <button className="btn btn-secondary" onClick={handleExport}>
                                Export{" "}
                                <img src="./assets/images/data-center/excel-sheet-icon.svg" alt="Export Excel" />
                            </button>
                        </div>
                        <button className="btn btn-primary d-flex align-items-center gap-2" onClick={handleRestore}>
                            Restore this version
                        </button>
                    </div>
                </div>

                <div className="table-responsive table-container">
                    {loading ? (
                        <p>Loading data...</p>
                    ) : (
                        <table className="table basic-border-table mb-0 table-hover">
                            <thead>
                                <tr>
                                    <th><input type="checkbox" /></th>
                                    {headers.map((header, idx) => (
                                        <th key={idx}>{header}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {rows.length === 0 ? (
                                    <tr>
                                        <td colSpan={headers.length + 1}>No data found</td>
                                    </tr>
                                ) : (
                                    rows.map((row, i) => (
                                        <tr key={i}>
                                            <td><input type="checkbox" /></td>
                                            {headers.map((header, ci) => (
                                                <td key={ci}>{row[header] || '-'}</td>
                                            ))}
                                        </tr>
                                    ))
                                )}
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td colSpan={2}></td>
                                    <td colSpan={headers.length - 2} className="fw-bold">Total Rows</td>
                                    <td className="text-center totalRowNumber">
                                        <span className="fw-bold">{filteredRows.length}</span>
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    )}
                </div>
            </div >
        </div >
    );
};

export default ViewVersionModal;
